import { ProjectsButchController } from "core/controllers/ProjectsButchController";
import { FC, ReactNode, useCallback, useEffect, useMemo, useState } from "react";
import { ContentWrapper, SelectShortListModalWrapper } from "./styles";
import {useModal} from "../../../core";
import { SendProjectModalWrapper } from "../sendProjects/employStyles";
import { SortingTypeIndex } from "shared/constants/sortingType";
import { SearchDataT, SendProjectsEntity } from "../sendProjects/SendProjectsEntity";
import {useIsMobile} from "@brg/ui";
import useQueryState from "shared/hooks/useQueryState";
import { RingPositions } from "shared/constants/ringPositionType";

export enum MODAL_TYPE {
    short_list = 'short_list',
    finalist = 'finalist',
    other = ''
}


export interface SelectShortListProps {
    onSetProjects: (projectIds: string[], position?: number) => void;
    onAddProject: (index: number, projectId: string) => void;
    projectIds: string[];
    competitionId: string;
    sortingMethods?: SortingTypeIndex[];
    tabs?: ReactNode;
    modalType?: MODAL_TYPE;
    showSearch?: boolean;
    activeTab?: string;
    sendText?: string;
    searchData?: SearchDataT;
    index: number;
    position: number;
}

export const SelectShortList: FC<SelectShortListProps> = (props) => {
    const { 
        onSetProjects, 
        projectIds, 
        competitionId, 
        index, 
        sortingMethods = undefined, 
        modalType = MODAL_TYPE.other,
        sendText,
        searchData = undefined, 
        tabs 
    } = props;
    const [selectedProjectIds, setSelectedProjectIds] = useState<string[]>([])
    const [{ tab }] = useQueryState();
    const [date, setDate] = useState(Date.now());
    const [sorting, setSorting] = useState(
        [MODAL_TYPE.short_list, MODAL_TYPE.finalist]?.includes(modalType) 
        ? SortingTypeIndex.score 
        : SortingTypeIndex.moderation
    );

    const modal = useModal();
    const isMobile = useIsMobile();

    useEffect(() => {
        setSelectedProjectIds(projectIds ?? []);
    }, [projectIds]);

    const selectedRequest = useMemo(
        () => 
            tab === 'selected_projects' && 
            [
                MODAL_TYPE.short_list, 
                MODAL_TYPE.finalist
            ]
            ?.includes(modalType)  
        , [tab, modalType]
    );

    const projectsFilter = useMemo(() => ({
        projectFilter: sorting,
        limit: 40,
        isLite: true,
        competitionIds: [competitionId],
        isContextIgnored: true,
        ...(!!selectedRequest && { projectIds: selectedProjectIds }),
    }), [competitionId, sorting, selectedRequest, tab]);

    const disablePtRequest = useMemo(() => ((selectedRequest && !selectedProjectIds?.length)), [selectedRequest, selectedProjectIds, tab]);

    const noProjectVisible = useMemo(() => (modalType === MODAL_TYPE.other && !projectIds?.length), [projectIds, modalType ]);

    const onSortingChange = useCallback((s: SortingTypeIndex): void => {
        setSorting(s);
        setDate(Date.now());
    }, []);

    const onMobileSortingClick = useCallback(() => {
        setSorting(sorting === 1 ? 3 : 1);
    }, [sorting, setSorting]);

    const onSelectProject = (projectId: string) => {
        if (selectedProjectIds.includes(projectId)) {
            const arr = selectedProjectIds.filter(item => item !== projectId);
            setSelectedProjectIds(arr);
        } else {
            const arr = [ ...selectedProjectIds ];
            arr.splice(index, 0, projectId)
            setSelectedProjectIds(arr);
        }
    }

    const onSubmit = () => {
        const arr = [ ...selectedProjectIds ];
        setSelectedProjectIds(arr);
        onSetProjects(arr, arr?.length);
        modal.hide();
    }

    const projectsContent = useMemo(() => {
        if (disablePtRequest) {
            return (
                <div />
            )
        }

        return (
            <ContentWrapper>
            <ProjectsButchController
                filter={projectsFilter}
                selectable={true}
                onSelect={onSelectProject}
                selectedProjects={selectedProjectIds}
                selectRingPosition={RingPositions.left}
                currentCompetitionId={competitionId}
                date={date}
                showCompetitionPoint
                isInfinityNeed={false}
                modal={true}
                metaAlwaysVisible
            />
            </ContentWrapper>
        )
    }, [projectsFilter, competitionId, isMobile, date, disablePtRequest, selectedRequest, onSelectProject, tab ])

    const disableSendButton = useMemo(() => (JSON.stringify(selectedProjectIds) === JSON.stringify(projectIds)), [selectedProjectIds, projectIds])

    return (
        <SelectShortListModalWrapper scroll={true}>
            <SendProjectModalWrapper offsetTop={isMobile ? 0 : 170} width={'100%'} directionMobile='column' direction='column' justify={'flex-start'} align={"center"} style={{ position: 'relative'}}>
                <SendProjectsEntity 
                    hideCount={!!tabs || noProjectVisible } 
                    hideFilter={noProjectVisible}
                    count={selectedProjectIds?.length || 0} 
                    isDisabledSendButton={disableSendButton} 
                    onMobileSortingClick={onMobileSortingClick} 
                    onSortingChange={onSortingChange}
                    sortingMethods={sortingMethods}
                    sendText={sendText}
                    searchData={searchData}
                    sorting={sorting} 
                    onSend={onSubmit}
                    tabs={tabs}
                >
                    {projectsContent}
                </SendProjectsEntity>
            </SendProjectModalWrapper>
        </SelectShortListModalWrapper>
    );
};
import { ProjectsButchController } from "core/controllers/ProjectsButchController";
import { FC, ReactNode, useCallback, useEffect, useMemo, useState } from "react";
import { ContentWrapper, SelectShortListModalWrapper } from "./styles";
import {useModal} from "../../../core";
import { SendProjectModalWrapper } from "../sendProjects/employStyles";
import { SortingTypeIndex } from "shared/constants/sortingType";
import { SearchDataT, SendProjectsEntity } from "../sendProjects/SendProjectsEntity";
import {useIsMobile} from "@brg/ui";
import useQueryState from "shared/hooks/useQueryState";
import { RingPositions } from "shared/constants/ringPositionType";

export enum MODAL_TYPE {
    short_list = 'short_list',
    finalist = 'finalist',
    other = ''
}


export interface SelectShortListProps {
    onSetProjects: (projectIds: string[], position?: number) => void;
    onAddProject: (index: number, projectId: string) => void;
    projectIds: string[];
    competitionId: string;
    sortingMethods?: SortingTypeIndex[];
    tabs?: ReactNode;
    modalType?: MODAL_TYPE;
    showSearch?: boolean;
    activeTab?: string;
    sendText?: string;
    searchData?: SearchDataT;
    index: number;
    position: number;
}

export const SelectShortList: FC<SelectShortListProps> = (props) => {
    const { 
        onSetProjects, 
        projectIds, 
        competitionId, 
        index, 
        sortingMethods = undefined, 
        modalType = MODAL_TYPE.other,
        sendText,
        searchData = undefined, 
        tabs 
    } = props;
    const [selectedProjectIds, setSelectedProjectIds] = useState<string[]>([])
    const [{ tab }] = useQueryState();
    const [date, setDate] = useState(Date.now());
    const [sorting, setSorting] = useState(
        [MODAL_TYPE.short_list, MODAL_TYPE.finalist]?.includes(modalType) 
        ? SortingTypeIndex.score 
        : SortingTypeIndex.moderation
    );

    const modal = useModal();
    const isMobile = useIsMobile();

    useEffect(() => {
        setSelectedProjectIds(projectIds ?? []);
    }, [projectIds]);

    const selectedRequest = useMemo(
        () => 
            tab === 'selected_projects' && 
            [
                MODAL_TYPE.short_list, 
                MODAL_TYPE.finalist
            ]
            ?.includes(modalType)  
        , [tab, modalType]
    );

    const projectsFilter = useMemo(() => ({
        projectFilter: sorting,
        limit: 40,
        isLite: true,
        competitionIds: [competitionId],
        isContextIgnored: true,
        ...(!!selectedRequest && { projectIds: selectedProjectIds }),
    }), [competitionId, sorting, selectedRequest, tab]);

    const disablePtRequest = useMemo(() => ((selectedRequest && !selectedProjectIds?.length)), [selectedRequest, selectedProjectIds, tab]);

    const noProjectVisible = useMemo(() => (modalType === MODAL_TYPE.other && !projectIds?.length), [projectIds, modalType ]);

    const onSortingChange = useCallback((s: SortingTypeIndex): void => {
        setSorting(s);
        setDate(Date.now());
    }, []);

    const onMobileSortingClick = useCallback(() => {
        setSorting(sorting === 1 ? 3 : 1);
    }, [sorting, setSorting]);

    const onSelectProject = (projectId: string) => {
        if (selectedProjectIds.includes(projectId)) {
            const arr = selectedProjectIds.filter(item => item !== projectId);
            setSelectedProjectIds(arr);
        } else {
            const arr = [ ...selectedProjectIds ];
            arr.splice(index, 0, projectId)
            setSelectedProjectIds(arr);
        }
    }

    const onSubmit = () => {
        const arr = [ ...selectedProjectIds ];
        setSelectedProjectIds(arr);
        onSetProjects(arr, arr?.length);
        modal.hide();
    }

    const projectsContent = useMemo(() => {
        if (disablePtRequest) {
            return (
                <div />
            )
        }

        return (
            <ContentWrapper>
            <ProjectsButchController
                filter={projectsFilter}
                selectable={true}
                onSelect={onSelectProject}
                selectedProjects={selectedProjectIds}
                selectRingPosition={RingPositions.left}
                currentCompetitionId={competitionId}
                date={date}
                showCompetitionPoint
                isInfinityNeed={false}
                modal={true}
                metaAlwaysVisible
            />
            </ContentWrapper>
        )
    }, [projectsFilter, competitionId, isMobile, date, disablePtRequest, selectedRequest, onSelectProject, tab ])

    const disableSendButton = useMemo(() => (JSON.stringify(selectedProjectIds) === JSON.stringify(projectIds)), [selectedProjectIds, projectIds])

    return (
        <SelectShortListModalWrapper scroll={true}>
            <SendProjectModalWrapper offsetTop={isMobile ? 0 : 170} width={'100%'} directionMobile='column' direction='column' justify={'flex-start'} align={"center"} style={{ position: 'relative'}}>
                <SendProjectsEntity 
                    hideCount={!!tabs || noProjectVisible } 
                    hideFilter={noProjectVisible}
                    count={selectedProjectIds?.length || 0} 
                    isDisabledSendButton={disableSendButton} 
                    onMobileSortingClick={onMobileSortingClick} 
                    onSortingChange={onSortingChange}
                    sortingMethods={sortingMethods}
                    sendText={sendText}
                    searchData={searchData}
                    sorting={sorting} 
                    onSend={onSubmit}
                    tabs={tabs}
                >
                    {projectsContent}
                </SendProjectsEntity>
            </SendProjectModalWrapper>
        </SelectShortListModalWrapper>
    );
};
